import { Mesh } from '@nivo/voronoi';
import React from 'react';
import { uiAppLogger } from 'apps/sigma2-ui/src/lib/logging';

export const CopilotCustomMeshLayer = (layerData: any) => {
  uiAppLogger.info('custom_mesh', layerData);
  const availableNodes = layerData.points
    .flatMap((set: unknown[]) => set)
    .filter((node: any) => node.serieId === 'series_pool');
  uiAppLogger.info('availableNodes', availableNodes);
  return (
    <Mesh
      nodes={[...availableNodes]}
      width={layerData.width}
      height={layerData.height}
      debug={false}
      onClick={layerData.onClick}
    />
  );
};
